import React, { useState } from 'react';

function CreaturesTable({ creatures, loading, selectedForComparison, onCompareToggle }) {
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortedCreatures = [...creatures].sort((a, b) => {
    const aVal = a[sortColumn];
    const bVal = b[sortColumn];
    const direction = sortDirection === 'asc' ? 1 : -1;

    if (aVal === null) return 1;
    if (bVal === null) return -1;

    if (typeof aVal === 'string') {
      return aVal.localeCompare(bVal) * direction;
    }
    return (aVal - bVal) * direction;
  });

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading creatures...</p>
      </div>
    );
  }

  return (
    <div className="creatures-table-container">
      <table className="creatures-table">
        <thead>
          <tr>
            <th className="checkbox-col">
              <input type="checkbox" disabled title="Select for comparison" />
            </th>
            <th onClick={() => handleSort('name')} className="sortable">
              Name {sortColumn === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('dungeon')} className="sortable">
              Dungeon {sortColumn === 'dungeon' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('slots')} className="sortable">
              Slots {sortColumn === 'slots' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('taming')} className="sortable">
              Taming {sortColumn === 'taming' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('class')} className="sortable">
              Class {sortColumn === 'class' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('combat')} className="sortable">
              Combat {sortColumn === 'combat' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('hits')} className="sortable">
              Hits {sortColumn === 'hits' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th>Damage</th>
            <th onClick={() => handleSort('wrestling')} className="sortable">
              Wrestling {sortColumn === 'wrestling' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('armor')} className="sortable">
              Armor {sortColumn === 'armor' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th>Resistances</th>
            <th>Abilities</th>
          </tr>
        </thead>
        <tbody>
          {sortedCreatures.map(creature => (
            <tr key={creature.id} className={selectedForComparison.includes(creature.id) ? 'selected' : ''}>
              <td className="checkbox-col">
                <input
                  type="checkbox"
                  checked={selectedForComparison.includes(creature.id)}
                  onChange={() => onCompareToggle(creature.id)}
                  disabled={!selectedForComparison.includes(creature.id) && selectedForComparison.length >= 5}
                />
              </td>
              <td className="creature-name">
                {creature.detail_url ? (
                  <a href={creature.detail_url} target="_blank" rel="noopener noreferrer" title="View on wiki">
                    {creature.name}
                  </a>
                ) : (
                  creature.name
                )}
              </td>
              <td>{creature.dungeon || '-'}</td>
              <td className="centered">{creature.slots}</td>
              <td className="centered">{creature.taming}</td>
              <td>
                <span className={`class-badge ${creature.class?.toLowerCase()}`}>
                  {creature.class}
                </span>
              </td>
              <td>{creature.combat}</td>
              <td className="centered">{creature.hits}</td>
              <td className="centered">
                {creature.min_dmg && creature.max_dmg
                  ? `${creature.min_dmg}-${creature.max_dmg}`
                  : '-'}
              </td>
              <td className="centered">{creature.wrestling || '-'}</td>
              <td className="centered">{creature.armor || '-'}</td>
              <td className="resistances">
                <div>Magic: {creature.magic_rst || 0}</div>
                <div>Poison: {creature.poison_rst || 0}</div>
                <div>Special: {creature.special_rst || 0}</div>
              </td>
              <td className="abilities">
                {creature.cooldown_ability && <div title="Cooldown">{creature.cooldown_ability}</div>}
                {creature.passive_ability && <div title="Passive">{creature.passive_ability}</div>}
                {creature.innate_ability && <div title="Innate">{creature.innate_ability}</div>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CreaturesTable;
